import { render, staticRenderFns } from "./DailyMilkRecording.vue?vue&type=template&id=4f5405b0&scoped=true&"
import script from "./DailyMilkRecording.vue?vue&type=script&lang=js&"
export * from "./DailyMilkRecording.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5405b0",
  null
  
)

export default component.exports